module.exports = __webpack_public_path__ + "media/images/icons/ic-info-9911f41e5346a46ec6e28701e618cac8.svg";